import { DURATION as D1 } from 'app/ui/core/common/InnerTransition';
import { DURATION as D2 } from '../../main/RouteTransition';
import MountAfterDelay from '../../core/common/MountAfterDelay';
import React from 'react';

export default function MountAfterTransition({ children, render }) {
  return (
    <MountAfterDelay timeout={getDelay()} render={render}>
      {children}
    </MountAfterDelay>
  );
}

export function getDelay() {
  return Math.max(D1, D2);
}



// WEBPACK FOOTER //
// ./src/app/ui/pages/shared/MountAfterTransition.js